/**
 * curriculum.json and curiosoMap.json are now stored on S3 in aqua-extended bucket. direct link
 * to Field Observer curriculum folder:
 * https://s3.console.aws.amazon.com/s3/buckets/aqua-extended/gc/field_observer/curriculum/?region=us-west-2&tab=overview
 *
 * This file is to store the curriculum when it is fetched and offer hooks to retrieve the fetched curriculum when needed.
 *
 * Current Curriculums are generated in the Field Observer Content Spreadsheet in two different pages, link to workbook:
 * https://docs.google.com/spreadsheets/d/1ksvnEQ4Onior_nkwmHBGBsGCfm5JbV53qTFF8EQcyGg/edit#gid=0
 */
let curriculum = {};
let curiosoMap = {};
let levelCount = 0;

export const getCurriculum = () => curriculum;
export const setCurriculum = (c) => {
  curriculum = c;
  levelCount = c.content.length;
};

export const getCuriosoMap = () => curiosoMap;
export const setCuriosoMap = (cm) => { curiosoMap = cm; };

export const getLevelCount = () => levelCount;
